<template>
  <section class="section-base form-section-base form-base">
    <div class="form-section-base__controls">
      <v-row>
        <v-col>
          <v-checkbox
            v-model="isApplicant"
            :label="ApplicantRightholderText.LABEL"
            hide-details
          />
        </v-col>
      </v-row>
    </div>

    <v-container>
      <template v-if="isApplicant">
        <div class="form-section-base__title">
          {{ ApplicantRightholderText.TITLE }}
        </div>

        <Person :v="$v.person" />
      </template>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import { checkInvalid, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import Person, { personModel, personValidation } from './Person';
import { ApplicantRightholderText } from '@/constants';

export default {
  name: 'ApplicantRightholder',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Person,
    Footer,
  },
  data() {
    return {
      StepDirection,
      leaveStep,
      StepName,
      isApplicant: false,
      invalidFields: [],
      person: cloneDeep(personModel),
      ApplicantRightholderText,
    };
  },
  validations() {
    return {
      person: personValidation(this.person),
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    touchFields() {
      this.invalidFields = [];

      if (!this.isApplicant) return;

      this.$v.person.$touch();
      checkInvalid(this.$v.person, this.invalidFields);
    },

    prefillDraft() {
      const applicantStore = cloneDeep(
        ServicesModule.statement.subjects.applicantRightholder
      );

      if (!applicantStore?.person) {
        return;
      }

      this.person = deepmerge(personModel, applicantStore.person);

      if (this.person.isTrustee) {
        this.person.trustee = deepmerge(
          personModel.trustee,
          applicantStore.trustee
        );
      }

      this.isApplicant = true;
    },

    assemblyModel() {
      if (!this.isApplicant) return null;

      const applicant = {};

      applicant.person = cloneDeep(this.person);

      if (applicant.person.isTrustee) {
        applicant.trustee = cloneDeep(this.person.trustee);
        applicant.person.phone = null;
      }

      return applicant;
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StepName.S2,
      });
    },
  },
};
</script>
